import React, { useEffect, useState } from "react";
import { ErrLine } from "./AvailabilityScreen";
import { LIMIT, Strip } from "./intakeShared";

export function DirectionTile({ saved, rewritten, onSave }) {
  const [v, setV] = useState(saved);
  const [over, setOver] = useState(0);
  const [err, setErr] = useState(false);
  useEffect(() => setV(saved), [saved]);
  const n = v.length;
  const blur = async () => {
    if (n > LIMIT) { setOver(n - LIMIT); return; }
    setOver(0);
    if (v === saved) return;
    try { await onSave(v); setErr(false); } catch { setErr(true); }
  };
  return (
    <Strip testid="in-dir-strip">
      <textarea value={v} onChange={(e) => setV(e.target.value)} onBlur={blur} aria-label="Direction" data-testid="in-dir-text"
        className="w-full rounded-[12px] border border-[#E9E9EC] px-3 py-2.5 text-[13.5px] text-[var(--ink)] outline-none focus:border-[#5856D6] focus:shadow-[0_0_0_3px_rgba(88,86,214,.16)] transition-[border-color,box-shadow]"
        style={{ minHeight: 150 }} />
      <div className="flex items-start justify-between gap-4">
        <div className="text-[13px] text-[var(--gray2)]">
          <div>Lumina also follows this during the visit's adaptive intake.</div>
          {rewritten != null && rewritten === saved && v === saved ? <div className="mt-0.5" data-testid="in-dir-rewritten">Rewritten from your questions when you last saved them.</div> : null}
        </div>
        <span className={`text-[12.5px] tabular-nums whitespace-nowrap ${n > LIMIT ? "text-[#B3261E] font-semibold" : "text-[var(--gray3)]"}`} data-testid="in-dir-count">{n.toLocaleString()} / 1,500</span>
      </div>
      {over ? <ErrLine testid="in-dir-over">Direction is {over.toLocaleString()} characters over the 1,500 limit. It isn't saved until it fits.</ErrLine> : null}
      {err ? <ErrLine testid="in-dir-error">Couldn't save. Change anything to try again.</ErrLine> : null}
    </Strip>
  );
}
